module.exports = __webpack_public_path__ + "img/c-cn.4aa7d6ee.png";